module.exports = __webpack_public_path__ + "img/header.26653a68.png";